import axios from 'axios'
import pageKeys from '../common/pagekeys'
import store from '@/store'

export default {
    async getSummary() {
        try {
            //My Attendance > Overtime main page
            const response = await axios.get(`Overtime/summary`, {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })            
            return response
        }catch(error){
            console.log('Overtime api getSummary error')
            throw error
        }
    },
    async getSummaryByTeam() {
        try {
            const response = await axios.get(`Overtime/${store.state.selectedTeamId}/summary`, {
                headers: {
                    'page_key': pageKeys.overtime_team_approver
                }
            })            
            return response
        }catch(error){
            console.log('Overtime api getSummaryByTeam error')
            throw error
        }
    },
    async getByCutoffByTeam(cutOffId) {
        try
        {            
            //My Team > Overtime main > By Cutoff
            const response = await axios.get(`Overtime/${store.state.selectedTeamId}/cutoff/${cutOffId}`, {
                headers: {
                    'page_key': pageKeys.overtime_team_approver
                }
            })                                   
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getByFYByTeam(fiscalYear) {
        try
        {            
            const response = await axios.get(`Overtime/${store.state.selectedTeamId}/fy/${fiscalYear}`, {
                headers: {
                    'page_key': pageKeys.overtime_team_approver
                }
            })                                   
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getByCutoffByUser(cutOffId) {
        try
        {            
             //My Attendance > Overtime main > By Cutoff   
            const response = await axios.get(`Overtime/cutoff/${cutOffId}/user`, {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })                       
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getByFYByUser(fiscalYear) {
        try
        {            
            const response = await axios.get(`Overtime/fy/${fiscalYear}/user`, {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })                       
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async add(data) {
        try
        {            
            const response = await axios.post(`Overtime`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Overtime api add error')
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.patch(`Overtime`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Overtime api update error')
            throw error
        }
    },
    async forReview(data) {
        try
        {            
            const response = await axios.post(`Overtime/forreview`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Overtime api forReview error')
            throw error
        }
    },
    async approve(data, pageKey) {
        try
        {            
            const response = await axios.post(`Overtime/approve`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('Overtime api approve error')
            throw error
        }
    },
    async approveAll(data) {
        try
        {            
            const response = await axios.post(`Overtime/approveall`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.overtime_team_approver
                }
            })                
            return response
        }
        catch (error)
        {
            console.log('Overtime api approveAll error')
            throw error
        }
    },
    async delete(data) {
        try
        {            
            const response = await axios.post(`Overtime/delete`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })                
            return response
        }
        catch (error)
        {
            console.log('Overtime api delete error')
            throw error
        }
    },
    async undoDelete(data) {
        try
        {            
            const response = await axios.post(`Overtime/undodelete`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })                
            return response
        }
        catch (error)
        {
            console.log('Overtime api delete error')
            throw error
        }
    },
    async reject(data, pageKey) {
        try
        {            
            const response = await axios.post(`Overtime/reject`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })                 
            return response
        }
        catch (error)
        {
            console.log('Overtime api reject error')
            throw error
        }
    },
    async rejectAll(data) {
        try
        {            
            const response = await axios.post(`Overtime/rejectall`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.overtime_team_approver
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Overtime api rejectAll error')
            throw error
        }
    },
    async forReviewAll(data) {
        try
        {            
            const response = await axios.post(`Overtime/forreviewall`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('Overtime api forReviewAll error')
            throw error
        }
    },
    async getByUser(transDate) {
        try
        {            
            const response = await axios.get(`Overtime/byuser/${transDate}`, {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })                                  
            return response
        }
        catch (error)
        {
            console.log('Overtime api getByUser error')
            throw error
        }
    },
    async getById(overtimeId, pageKey) {
        try
        {            
            const response = await axios.get(`Overtime/${overtimeId}`, {
                headers: {
                    'page_key': pageKey
                }
            })                                   
            return response
        }
        catch (error)
        {
            console.log('Overtime api getById error')
            throw error
        }
    },   
    async getOffsetDetails() {
        try
        {            
            const response = await axios.get(`Overtime/offsetdetails`, {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })                                  
            return response
        }
        catch (error)
        {
            console.log('Overtime api getOffsetDetails error')
            throw error
        }
    },
    async getMonthlyByUser(month) {
        try
        {            
            const response = await axios.get(`Overtime/byuser/monthly/${month}`, {
                headers: {
                    'page_key': pageKeys.overtime
                }
            })                                   
            return response
        }
        catch (error)
        {
            console.log('Overtime api getMonthlyByUser error')
            throw error
        }
    }
}